/* The shared date filter, held in the URL, for any page. [Jarvis · Claude] 2026-10-26
 *   const df = useDateFilter('orders')
 *   const { rows, summary } = df.apply(list)
 *   <DateFilter {...df.props} summary={summary} noun="orders" />
 */
import { useCallback, useMemo, useRef } from 'react'
import { useSearchParams } from 'react-router-dom'
import { readDateFilter, writeDateFilter, applyDateFilter, SURFACE_DATES } from './dateFilter.js'

export function useDateFilter(surface) {
  const [params, setParams] = useSearchParams()
  const now = useRef(new Date()).current
  const value = useMemo(() => readDateFilter(params), [params])
  const onChange = useCallback(
    (next) => setParams((previous) => writeDateFilter(previous, next), { replace: true }),
    [setParams],
  )
  const spec = SURFACE_DATES[surface]
  const apply = useCallback((rows) => applyDateFilter(rows || [], value, spec.dateOf, now), [value, spec, now])
  return { value, onChange, spec, apply, props: { value, onChange, label: spec.label, id: `df-${surface}` } }
}
